export default "__VITE_ASSET__lgKsU7b1__"